import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';
import LayoutProvider from '../../../../Contexts/LayoutProvider';
import PageTitle from '../../../../utils/PageTitle';
import { mkRelativeUrl } from '../../../../utils/URL';
import InvoiceListProvider, { useBillingUnauthorized } from './UnauthorizedListProvider';
import InvoiceTableMobile from './components/InvoiceTableMobile';
import InvoiceListPageHeader from './components/UnauthorizedListPageHeader';
import InvoiceListPageHeaderMobile from './components/UnauthorizedListPageHeaderMobile';
import InvoiceTable from './components/UnauthorizedListTable';

function PageCont() {
    const navigate = useNavigate();
    const { invoiceData, setParams } = useBillingUnauthorized();
    // Search Params
    const [searchParams] = useSearchParams();
    const [queryStr, setQueryStr] = useState({ q: searchParams.get('q') || '' });
    const p = useMemo(
        () => ({
            q: searchParams.get('q') || '',
            status: searchParams.get('status') || '',
            'order-by': searchParams.get('order-by') || 'id',
            sort: searchParams.get('sort') || 'desc',
            page: searchParams.get('page'),
            cpp: searchParams.get('cpp') || '12'
        }),
        [searchParams]
    );

    const debounceUpdate = useDebouncedCallback((val) => {
        navigate(mkRelativeUrl('/billing/invoices', { ...p, q: val }));
    }, 400);

    const handleChangeFilterData = (e) => {
        const { name, value } = e.target;
        if (name) {
            if (name === 'q') {
                setQueryStr({ q: value });
                debounceUpdate(value);
            } else {
                navigate(mkRelativeUrl('/billing/invoices', { ...p, [name]: value }));
            }
        }
    };
    const onChangePage = (page) => {
        navigate(mkRelativeUrl('/billing/invoices', { ...p, page }));
    };

    // For mobile view reset filter
    const onResetFilter = () => {
        navigate(mkRelativeUrl('/billing/invoices', { q: '', status: '' }));
    };

    const handleSortingData = (column) => {
        navigate(
            mkRelativeUrl('/billing/invoices', {
                ...p,
                'order-by': column,
                sort: p.sort === 'desc' ? 'asc' : 'desc'
            })
        );
    };

    useEffect(() => {
        setParams(p);
    }, [p, setParams]);

    return (
        <div className="inner_page_cont">
            <LayoutProvider>
                <InvoiceListPageHeader
                    layout="default"
                    onChangeHandler={handleChangeFilterData}
                    p={{ ...p, ...queryStr }}
                />
                <InvoiceListPageHeaderMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    onResetFilter={onResetFilter}
                    onChangeHandler={handleChangeFilterData}
                    p={{ ...p, ...queryStr }}
                />
            </LayoutProvider>

            <LayoutProvider>
                <InvoiceTable
                    onSortedHandler={handleSortingData}
                    sortedColumn={p['order-by']}
                    sortBy={p.sort}
                    layout="default"
                    data={invoiceData}
                    onChangePage={onChangePage}
                />
                <InvoiceTableMobile layout={['md', 'sm', 'xs', 'xxs']} data={invoiceData} />
            </LayoutProvider>
        </div>
    );
}

function UnauthorizedListPage() {
    // set page title
    PageTitle(`Unauthorized Invoice List`);

    return (
        <InvoiceListProvider>
            <PageCont />
        </InvoiceListProvider>
    );
}

export default UnauthorizedListPage;
